import React from 'react';
import type { Event, EventHeroScopedProps } from './types';
import styles from './EventHero.module.scss';
import { HeroCarousel } from './HeroCarousel';
import { getImageProps } from 'next/image';

export type EventHeroProps = {
  eventName: Event['name'];
} & EventHeroScopedProps &
  Pick<Event, 'hasCroppedLogo'>;

export const EventHero = ({
  mainBodyBackground: { croppedLogoUrl50 },
  items = [],
  eventName,
  featuredVideo,
  nativeVideo,
}: EventHeroProps) => {
  const shouldShowEventHero = items.length > 0 || featuredVideo || nativeVideo;
  const backgroundImage = croppedLogoUrl50 || nativeVideo?.thumbnail || featuredVideo?.thumbnail?.small?.url;
  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 50,
    height: 25,
    src: backgroundImage || '',
  });

  if (!shouldShowEventHero) {
    return null;
  }

  return (
    <div className={styles.root} data-testid="event-hero">
      <div className={styles.hero}>
        <div className={styles.background} style={{ backgroundImage: `url("${src}")` }}></div>
        <HeroCarousel eventName={eventName} items={items} featuredVideo={featuredVideo} nativeVideo={nativeVideo} />
      </div>
    </div>
  );
};
